import * as Sentry from '@sentry/react';
import {
  queryOptions,
  useQuery,
  useQueryClient,
  useSuspenseQuery,
} from '@tanstack/react-query';

import { getCountryDataForCountryCodeWithFallback } from 'src/utils/countryDetector';
import type { CountryData } from 'src/utils/countryList';

import { myRmApi } from '../endpoints';
import { queryKeys } from './queryKeys';

export const queryCountry = () =>
  queryOptions({
    queryKey: queryKeys.country.detected,
    queryFn: async () => {
      const countryCode = await myRmApi.getCountry();

      return getCountryDataForCountryCodeWithFallback(countryCode);
    },
    staleTime: Infinity,
  });

export function useCountrySuspense() {
  return useSuspenseQuery(queryCountry());
}

export const useCountry = () => {
  const setCountry = useSetCountry();

  return {
    ...useQuery(queryCountry()),
    setCountry,
  };
};

export const useSetCountry = () => {
  const queryClient = useQueryClient();

  return async (country: CountryData) => {
    Sentry.setTag('country', country.value);
    await queryClient.cancelQueries({ queryKey: queryKeys.country.detected });
    return queryClient.setQueryData(queryKeys.country.detected, country);
  };
};
